module.exports = __webpack_public_path__ + "public/img/logo_amikom_180.1a418ce2.png";